import { render, staticRenderFns } from "./DomainsAddNew.vue?vue&type=template&id=0ca712e4"
import script from "./DomainsAddNew.vue?vue&type=script&lang=js"
export * from "./DomainsAddNew.vue?vue&type=script&lang=js"
import style0 from "./DomainsAddNew.vue?vue&type=style&index=0&id=0ca712e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports